<template>
  <div>
    <Container
      :title="$t('region.public.leave_name', { name })"
      tag="publicRegionLeave"
      :container-is-expanded="false"
    >
      <div class="list-group-item" v-text="$t(leaveText, { name })" />
      <ContainerButton
        variant="danger"
        :text-key="isWorkGroup ? 'region.public.leave_group' : 'region.public.leave'"
        icon="fas fa-user-slash"
        :disabled="loading"
        @click="removeMeFromRegion"
      />
    </Container>
  </div>
</template>

<script>
import Container from '@/components/Container/Container.vue'
import { leaveRegion } from '@/api/regions'
import { HTTP_RESPONSE } from '@/consts'
import { pulseError } from '@/script'
import useConfirmationDialogue from '@/composables/useConfirmationDialogue'
import ContainerButton from '@/components/Container/ContainerButton.vue'
import { useUserStore } from '@/stores/user'

export default {
  components: { Container, ContainerButton },
  props: {
    regionId: { type: Number, required: true },
    name: { type: String, required: true },
    isWorkGroup: { type: Boolean, default: false },
  },
  setup () {
    const userStore = useUserStore()
    const { confirmationDialogue } = useConfirmationDialogue()
    return { confirmationDialogue, userStore }
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    translationKey () {
      if (this.isWorkGroup) {
        return 'group.quit_name_workgroup'
      } else if (this.isHomeRegion) {
        return 'group.quitting_home_district_warning'
      } else {
        return 'group.really_quit_district'
      }
    },
    leaveText () {
      if (this.isWorkGroup) {
        return 'region.public.leave_text_group'
      } else {
        return 'region.public.leave_text_region'
      }
    },
    isHomeRegion () {
      return this.userStore.getHomeRegion === this.regionId
    },
  },
  methods: {
    async removeMeFromRegion () {
      const confirmed = await this.confirmationDialogue(this.translationKey, {
        title: this.$t('are_you_sure'),
        okTitle: this.$t('button.yes_i_am_sure'),
        okVariant: 'danger',
        params: { name: this.name },
        countdown: this.isHomeRegion ? 30 : 5,
      })

      if (!confirmed) return

      try {
        this.loading = true
        await leaveRegion(this.regionId)
        const redirectLocation = this.$url('publicRegion', this.regionId)
        location.href = this.$url('relogin_and_redirect_to_url', redirectLocation)
      } catch (err) {
        if (err.code && err.code === HTTP_RESPONSE.CONFLICT) {
          pulseError(this.$t('region.conflict_store_member_or_manager_self'))
        } else {
          pulseError(this.$t('error_unexpected'))
          throw err
        }
      }
    },
  },
}
</script>
